'use client';

import { useState } from 'react';
import { usePathname } from 'next/navigation';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { ChatLauncher } from "@/components/ChatLauncher";
import { Button } from '@/components/ui/button';

interface AppLayoutProps {
  children: React.ReactNode;
}

const PUBLIC_ROUTES = ['/login'];

export function AppLayout({ children }: AppLayoutProps) {
  const pathname = usePathname();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const isPublicRoute = PUBLIC_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'));

  if (isPublicRoute) {
    return (
      <div className="min-h-screen">
        {children}
      </div>
    );
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar isCollapsed={isCollapsed} />

      {/* Toggle Button */}
      <Button
        variant="outline"
        size="icon"
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="fixed top-2 z-50 transition-all duration-300 h-6 w-6 rounded-full shadow-md"
        style={{
          left: isCollapsed ? 'calc(3.5rem - 0.75rem)' : 'calc(15rem - 0.75rem)',
        }}
      >
        {isCollapsed ? (
          <ChevronRight className="w-3 h-3" />
        ) : (
          <ChevronLeft className="w-3 h-3" />
        )}
      </Button>

      <main
        className="flex-1 transition-all duration-300 pt-0 px-6 pb-6"
        style={{
          marginLeft: isCollapsed ? '3.5rem' : '15rem',
        }}
      >
        {children}
      </main>
      <ChatLauncher />
    </div>
  );
}

export default AppLayout;
